<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm"><a class="xref" href="#/wsutvmamericans0008#acknow" id="racknow">Acknowledgments</a></p>
<p class="tocf"><a class="xref" href="#/wsutvmamericans0009#intro" id="rintro">Introduction: The Cold War and Homemade Brownies</a></p>
<p class="toc"><a class="xref" href="#/wsutvmamericans0010#ch01" id="rch01">1. Wigs, Sex, and Women’s Work</a></p>
<p class="toc"><a class="xref" href="#/wsutvmamericans0011#ch02" id="rch02">2. Marriage and Bromance</a></p>
<p class="toc"><a class="xref" href="#/wsutvmamericans0012#ch03" id="rch03">3. Family TV</a></p>
<p class="tocbmf"><a class="xref" href="#/wsutvmamericans0013#wrk_ctd" id="rwrk_ctd">Works Cited</a></p>
<p class="tocbm"><a class="xref" href="#/wsutvmamericans0014#index" id="rindex">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-tvmamericans-0007.vue?7c389643